import React, { useEffect, useState } from 'react';
import { Paper, Alert } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import TotalAmountLabels from './Components/TotalAmountLabels';
import EntryTable from './Components/EntryTable';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { showSuccessSnackbar } from '../../components/snackBar/snakbar';
import InvoiceBasicDetails from './Components/InvoiceBasicDetails';
import PaymentDetails from './Components/PaymentDetails';
import MultiFileAttachment from './Components/MultiFileAttachment';
import Description from './Components/Description';
import Grid from '@mui/material/Grid';
import HsnandJournalTab from './Components/HsnandJournalTab';
import { API, graphqlOperation } from 'aws-amplify';

import {
  createPurchaseInvoice,
  createTransactionWithSpecificTime,
  deleteTransactionMaster,
  getMinMaxInvoiceDate,
  getPurchaseMasterCustom,
} from '../../graphql';
import Loader from './Components/Loader';
import './Components//Invoice.css';
import printJS from 'print-js';
import { PurchaseTaxablePrint } from '../../library/InvoicePrint';

import ConfirmCancel from '../../components/modals/confirmCancel';
import { ShareModal } from '../../components/modals/Share';
import { useSendEmailModal } from '../../features/Email';
import axios from 'axios';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { uploadToServer } from '../../library/upload';
import ConfirmExit from '../../components/modals/ConfirmExit';
import DraggableAction from '../../components/Buttons/DraggableAction';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { useListGeneralSettingQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import { createPurchaseBatch, createPurchaseBatchWithoutImages } from '../../graphql/postgress_graphql/customMutations';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import { useGetPaymentSettingsQuery } from '../../redux/apis/paymentSettings.api';
import { useStateList } from './Components/HandleInvoiceStateProvider';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import UseVoucherDetails from './Components/UseVoucherDetails';
import { fetchAndPrintPDF } from '../../utils/common';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { updateTitle } from '../../redux/reducers/titleSlice';
import CancelUI from '../../components/Ui/CancelUI';
import EInvAuth from './Modals/EInvAuth';
import dayjs from 'dayjs';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

function NewPurchaseInvoiceTaxPrime({ isVoucher, accountDetails }) {
  const dispatch = useDispatch();
  dispatch(display());
    
  const { getVoucherDetails } = UseVoucherDetails();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  let location = useLocation();
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,

    pdflink: new URLSearchParams(window.location.search).get('pdflink') || '',
  };

  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
    const { data: companyPreference } = useListCompanyPreferenceQuery();
    const postingDatePref = companyPreference?.find(
      (p) => p.attributetypecd === 'MyPostingDate' && String(p?.additionalvalue ?? '') === String(userPreferece?.financialYear?.financialyearid ?? '')
    );
    const currentPostingDate = postingDatePref?.attributevalue;
     const [savedPostingDate,setSavedPostingDate]=useState("");

  const {
    initialState,
    setInitialState,
    data,
    setData,
    cancelModal,
    setCancelModal,
    state,
    setState,
    cancelModalStatus,
    setCancelModalStatus,
    itemData,
    setItemData,
    deleteModalStatus,
    setDeleteModalStatus,
    viewMode,
    setViewMode,
    setPaymentAccordion,
    invoiceEntry,
    deletedItems,
    deletedNonItems,
    setInvoiceEntry,
    totTaxAmt,
    totDiscount,
    totGSTCess,
    totNetAmt,
    totGST,
    totAmt,
    companyState,
    netAmountToPay,
    companyData,
    partyBillAddressEntity,
    partyDeliveryAddressEntity,
    invTransArr,
    paymentTransArr,
    itemsRows,
    initialAttachments,
    transGeneralSettingsFlag,
    partyAccountID,
    linkedTransArr,
    voucherArr,
    paymentTransID,
    backdropOpen,
    setBackdropOpen,
    units,
    partyType,
    setPosition,
    isDragging,
    setIsDragging,
    offset,
    setFirstInvoiceDate,
    registrationType,
    setTabValue,
    setItemValid,
    setNonItemValid,
    tableErrArr,
    setTableErrArr,
    items,
    setItems,
    nonItems,
    eWayImp,
    setNonItems,
    billingAddressDetails,
    deliveryAddressDetails,
    initItemTableDta,
    initNonItemTableData,
    previewSalesTaxableModal,
    setPreviewSalesTaxableModal,
    setATags,
    currentDouments,
    resetData,
    resetItems,
    resetNonItems,
    setItemsRows,
    firstInvoiceDate,
    lastInvoiceDate,
    nextInvoiceDate,
  } = useStateList();
  function isEmptyDeliveryAddress(details) {
    const { deliveryAddress, states, district, country, pincode, stateCD, countryCD, districtCD, gstin, customerName } = details;

    const isEmptyVal = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '' || val === '0';
      if (typeof val === 'object') {
        return Object.values(val).every((v) => v === '' || v === null || v === undefined || v === '0');
      }
      return false;
    };

    return (
      isEmptyVal(deliveryAddress) &&
      isEmptyVal(states?.value) &&
      isEmptyVal(district?.value) &&
      isEmptyVal(country?.value) &&
      isEmptyVal(pincode) &&
      isEmptyVal(stateCD) &&
      isEmptyVal(countryCD) &&
      isEmptyVal(districtCD) &&
      isEmptyVal(gstin) &&
      isEmptyVal(customerName)
    );
  }

  const isConsigneeEmpty = data?.consigneeName === '' || data?.consigneeGST === '';
  const isEmptyInvDeliveryAddress = isEmptyDeliveryAddress(deliveryAddressDetails);
  const isEmptyPartyDelivery =
    !partyDeliveryAddressEntity ||
    (Object.keys(partyDeliveryAddressEntity).length === 0 && partyDeliveryAddressEntity.constructor === Object);
  const isAdrressEmpty = !isEmptyInvDeliveryAddress || !isEmptyPartyDelivery || !isConsigneeEmpty;
  const newItemObj = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: '' },
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: '',
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
  };
  const newNonItemObj = {
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    description: '',
    taxableAMount: 0,
GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  };
  const [reNavigate, setReNavigate] = useState('');
  const [connectCheckbox, setConnectCheckbox] = useState('');
  const [eInvAuthModalProps, setEInvAuthModalProps] = useState({ open: false });
  let [modalOpen, setModalOpen] = useState(false);
  let saveV = true;
const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'PurchaseInvoice',
      financialyearid: userPreferece?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  function deepEqual(obj1, obj2) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 === obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log(obj1[key], obj2[key], key);
        return false;
      }
    }

    return true;
  }

  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);
  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  // useEffect(() => {
  //   if (
  //     !deepEqual(data, initialState) ||
  //     itemsRows.length !== initialAttachments.length
  //   ) {
  //     dispatch(setNavigationBlocked(true));
  //   }
  //   if (itemsRows.length === initialAttachments.length) {
  //     itemsRows.map((e, index) => {
  //       if (!deepEqual(itemsRows[index], initialAttachments[index])) {
  //         dispatch(setNavigationBlocked(true));
  //       }
  //     });
  //   }
  //   return () => {
  //     dispatch(setNavigationBlocked(false));
  //   };
  // }, [data, aTags, itemsRows]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (data?.voucherNumber) {
      dispatch(updateTitle(data.voucherNumber));
    }
    if (params.view) return;
    const isDataModified = JSON.stringify(data) !== JSON.stringify(initialState);
    const isAttachmentsModified = itemsRows.length !== initialAttachments.length;

    const shouldBeDirty = isDataModified || isAttachmentsModified;

    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [data, itemsRows, initialState, initialAttachments, isDirty]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);
  const ewayNav = (data, id, partyId, saveNew) => {
    console.log(dayjs(data.invoiceDate).format('DD/MM/YYYY'), 'datacccc');
    navigate('/addewaybill', {
      state: {
        invoice: {
          docDate: dayjs(data.invoiceDate).format('DD/MM/YYYY'),
          id,
          invoiceNo: data.voucherNumber,
          // irn: data.irn,
          placeofsupply: data.value,
          supply: 'I',
          partyId,
          invoiceType: 'PurchaseInvoice',
        },
        connect: 'invoice',
        from: location.pathname,
        saveNew,
      },
    });
  };
  const endDrag = () => setIsDragging(false);
  useEffect(() => {
    const onDrag = (e) => {
      if (!isDragging) return;
      let newY = e.clientY - offset.y;
      let newX = e.clientX - offset.x;
      newY = Math.max(300, newY);
      newY = Math.min(640, newY);
      newX = Math.max(100, newX);
      newX = Math.min(1445, newX);
      setPosition((prevPosition) => ({
        ...prevPosition,
        y: newY,
        x: newX,
      }));
    };

    if (isDragging) {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('mouseup', endDrag);
      return () => {
        window.removeEventListener('mousemove', onDrag);
        window.removeEventListener('mouseup', endDrag);
      };
    }
  }, [isDragging, offset.x, offset.y]);

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  function formVaidation(objData) {
    let isvalid = true;
    let errorArr = [];
    let obj = { ...data };
    Object.keys(objData).map((itemKey) => {
      if (itemKey === 'partyName') {
        if (objData[itemKey]?.label == '') {
          isvalid = false;
          obj.errorFields.partyName = 'Supplier Name is required';
          obj.errorStatus.partyName = true;
          errorArr.push('Supplier Name');
        } else {
          obj.errorFields.partyName = '';
          obj.errorStatus.partyName = false;
        }
      }

      if (itemKey === 'seriesVouchers') {
        if (objData[itemKey]?.label == '') {
          isvalid = false;
          obj.errorFields.seriesVouchers = 'Voucher Series Name is required';
          obj.errorStatus.seriesVouchers = true;
          errorArr.push('Voucher Series Name');
        } else {
          obj.errorFields.seriesVouchers = '';
          obj.errorStatus.seriesVouchers = false;
        }
      }
      if (itemKey === 'currencyRate') {
        if (objData[itemKey] === 0 || objData[itemKey] === '') {
          isvalid = false;
          setTabValue('2');
          showWarningSnackbar('Please enter the Currency Rate');
          obj.errorStatus.currencyRate = true;
          errorArr.push('Currency Rate');
        } else {
          obj.errorFields.currencyRate = '';
          obj.errorStatus.currencyRate = false;
        }
      }
       
      if (itemKey === 'invoiceDate') {
        const startDate = userPreferece.financialYear.startdate * 1000;
        const endDate = userPreferece.financialYear.enddate * 1000;

        const minDate = moment(params?.id && !isNaN(params.id) ? firstInvoiceDate || startDate : firstInvoiceDate || startDate);

        const maxDate = moment(params?.id && !isNaN(params.id) ? nextInvoiceDate || endDate : endDate);

        if (!objData[itemKey]?.trim()) {
          isvalid = false;
          obj.errorFields.invoiceDate = 'Voucher Date is required';
          obj.errorStatus.invoiceDate = true;
          errorArr.push('Voucher Date');
        } else if (moment(objData[itemKey], 'YYYY-MM-DD').isBefore(minDate) || moment(objData[itemKey], 'YYYY-MM-DD').isAfter(maxDate)) {
          isvalid = false;
          obj.errorFields.invoiceDate = `Voucher Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format(
            'DD MMM YYYY'
          )}`;
          showWarningSnackbar(`Voucher Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}`);
          obj.errorStatus.invoiceDate = true;
        } else {
          obj.errorFields.invoiceDate = '';
          obj.errorStatus.invoiceDate = false;
        }
      }
      if (itemKey === 'customerOrderDate') {
        if (objData[itemKey] && isNaN(moment(objData[itemKey]))) {
          isvalid = false;
          obj.errorStatus.customerOrderDate = true;
          obj.errorFields.customerOrderDate = 'Invalid date format';
        }
        //  else if (moment(objData[itemKey]) > moment(data?.invoiceDate)) {
        //   isvalid = false;
        //   obj.errorStatus.customerOrderDate = true;
        //   obj.errorFields.customerOrderDate = 'Customer Order Date cannot be later than Voucher Date';
        //   showWarningSnackbar('Customer Order Date cannot be later than Voucher Date');
        // }
         else {
          obj.errorFields.customerOrderDate = '';
          obj.errorStatus.customerOrderDate = false;
        }
      }
      if (itemKey === 'orderNumber') {
        obj.errorFields.orderNumber = '';
        obj.errorStatus.orderNumber = false;
      }
      if (registrationType != 1) {
        if (itemKey === 'taxability') {
          if (objData[itemKey].value === '') {
            isvalid = false;
            obj.errorFields.taxability = 'Taxability is required';
            obj.errorStatus.taxability = true;
            errorArr.push('Taxability');
          } else {
            obj.errorFields.taxability = '';
            obj.errorStatus.taxability = false;
          }
        }
      }
      if (itemKey === 'paymentType') {
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.paymentType = 'Payment Type is Required';
          obj.errorStatus.paymentType = true;
        } else {
          obj.errorFields.paymentType = '';
          obj.errorStatus.paymentType = false;
        }
      }

      if (itemKey === 'receivedAmount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Paid Amount is Required';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Amount should be less than Grand Total';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAmount = '';
            obj.errorStatus.receivedAmount = false;
          }
        }
      }

      if (itemKey === 'receivedAccount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey].value == '') {
            isvalid = false;
            obj.errorFields.receivedAccount = 'Paid Account is Required';
            obj.errorStatus.receivedAccount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAccount = '';
            obj.errorStatus.receivedAccount = false;
          }
        }
      }

      if (itemKey === 'creditPeriod') {
        if (objData['paymentType'] == 'Credit') {
          if (objData[itemKey] > 1000 || objData[itemKey] < 0) {
            isvalid = false;
            obj.errorFields.creditPeriod = 'Credit period should between 0 and 1000';
            obj.errorStatus.creditPeriod = true;
            showWarningSnackbar('Credit period should between 0 and 1000');
            setPaymentAccordion(true);
          } else {
            obj.errorFields.creditPeriod = '';
            obj.errorStatus.creditPeriod = false;
          }
        }
      }

      if (itemKey === 'adjustments') {
        if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(objData[itemKey]) && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.adjustments = 'Invalid Amount Format';
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = '';
          obj.errorStatus.adjustments = false;
        }
      }

      if (itemKey === 'placeOfSupply') {
        if (objData[itemKey].value?.length <= 0) {
          isvalid = false;
          obj.errorFields.placeOfSupply = 'Source Of Supply is Required';
          obj.errorStatus.placeOfSupply = true;
          errorArr.push('Source Of Supply');
        } else {
          obj.errorFields.placeOfSupply = '';
          obj.errorStatus.placeOfSupply = false;
        }
      }

      if (itemKey === 'bankReferenceNo') {
        if (objData['paymentType'] === 'Bank') {
          if (!new RegExp(/^\d{9,18}$/).test(objData[itemKey]) && objData[itemKey]?.trim().length > 0) {
            isvalid = false;
            obj.errorFields.bankReferenceNo = 'Invalid Bank/UPI Reference number';
            obj.errorStatus.bankReferenceNo = true;
          } else {
            obj.errorFields.bankReferenceNo = '';
            obj.errorStatus.bankReferenceNo = false;
          }
        }
      }
      // if(Number(voucherFlag)===-1){
         if (
  (!params?.id && Number(voucherFlag) === -1) ||
  (params?.id && invoiceEntry?.serialnumber === "")
) {
      if (itemKey === 'voucherNumber') {
         const { valid, message } = CheckVoucherValid(objData[itemKey],'Voucher Number');
        if (objData[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.voucherNumber = 'Voucher Number is Required';
          obj.errorStatus.voucherNumber = true;
          errorArr.push('Voucher Number');

        } else if(!valid){
                   isvalid = false;
                  obj.errorFields.voucherNumber =message;
                  obj.errorStatus.voucherNumber = true;
                  showWarningSnackbar(message);
                }
                   else {
          obj.errorFields.voucherNumber = '';
          obj.errorStatus.voucherNumber = false;
        }
      }
    }
      if (data.paymentType !== 'Credit') {
        if (itemKey === 'transactionVoucher') {
          if (objData[itemKey]?.trim().length <= 0) {
            isvalid = false;
            obj.errorFields.transactionVoucher = 'Voucher Number is Required';
            obj.errorStatus.transactionVoucher = true;
          } else {
            obj.errorFields.transactionVoucher = '';
            obj.errorStatus.transactionVoucher = false;
          }
        }
      }

      if (itemKey === 'remarks') {
        if (objData[itemKey]?.trim()?.length > 250 && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.remarks = 'Description must be less than 250 characters';
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = '';
          obj.errorStatus.remarks = false;
        }
      }
    });

    setData(obj);
    const validErrors = errorArr.filter((e) => !!e && e.trim?.().length > 0);

    if (!isvalid) {
      if (validErrors.length === 1) {
        showWarningSnackbar(`${validErrors[0]} is required`);
      } else if (validErrors.length > 1) {
        const lastField = validErrors.pop();
        const errorText = `${validErrors.join(', ')} and ${lastField} are required`;
        showWarningSnackbar(errorText);
      }
    }
    if (isvalid) {
      if (Number(totTaxAmt + totGST + totGSTCess) > 99999999999) {
        showWarningSnackbar(`Total Net Amount must be less than ${data?.currency?.sign}1,000 crore.`);
        isvalid = false;
      }
    }
    return isvalid;
  }
  // function checkEwayBillAddress() {
  //   if (!eWayImp) return true;
  
  //   const isBillingComplete = [
  //    billingAddressDetails?.district,
  //   billingAddressDetails?.billingAddress,
  //   billingAddressDetails?.pincode,
  //     billingAddressDetails?.states,
  //   billingAddressDetails?.city,
  //     billingAddressDetails?.country,
  //   ].every(Boolean);
  //   const isDeliveryComplete = [
  //     deliveryAddressDetails?.district,
  //   deliveryAddressDetails?.deliveryAddress,
  //   deliveryAddressDetails?.pincode,
  //     deliveryAddressDetails?.states,
  //   deliveryAddressDetails?.city,
  //     deliveryAddressDetails?.country,
  //   ].every(Boolean);
  
  //   let warningMessage = '';
  
  //   if (!isBillingComplete && !isDeliveryComplete) {
  //     warningMessage =
  //       'Add Billing Address & Shipping Address for this party to proceed with E-Way Bill creation';
  //   } else if (!isBillingComplete) {
  //     warningMessage =
  //       'Add Billing Address for this party to proceed with E-Way Bill creation';
  //   } else if (!isDeliveryComplete) {
  //     warningMessage =
  //       'Add Shipping Address for this party to proceed with E-Way Bill creation';
  //   }
  
  //   if (warningMessage) {
  //     showWarningSnackbar(warningMessage);
  //     return false;
  //   }
  
  //   return true; 
  // }
// function checkEwayBillAddress() {
//   if (!eWayImp) return true;

//   const isPresent = (v) => {
//     if (v == null) return false;
//     if (typeof v === "string") return v.trim().length > 0;
//     if (typeof v === "object") {
//       const label = v.label ? v.label.trim() : "";
//       const value = v.value ? v.value.trim() : "";
//       const code = v.code ? v.code.trim() : "";
//       return !!(label || value || code);
//     }
//     return !!v;
//   };

//   const getMissingFields = (details, type) => {
//     const fields = type === "Billing"
//       ? [
//           { key: "billingAddress", label: "Billing Address" },
//           { key: "district", label: "District" },
//           { key: "pincode", label: "Pincode" },
//           { key: "states", label: "State" },
//           { key: "city", label: "City" },
//           { key: "country", label: "Country" },
//         ]
//       : [
//           { key: "deliveryAddress", label: "Shipping Address" },
//           { key: "district", label: "District" },
//           { key: "pincode", label: "Pincode" },
//           { key: "states", label: "State" },
//           { key: "city", label: "City" },
//           { key: "country", label: "Country" },
//         ];
//     return [...new Set(fields
//       .filter(({ key }) => !isPresent(details?.[key]))
//       .map(({ label }) => label))];
//   };

//   const missingBilling = getMissingFields(billingAddressDetails, "Billing");
//   const missingShipping = getMissingFields(deliveryAddressDetails, "Shipping");

//   let warningMessage = "";
//   if (missingBilling.length && missingShipping.length) {
//     warningMessage = `Add ${missingBilling.join(", ")} in Billing Address and ${missingShipping.join(", ")} in Shipping Address to proceed with E-Way Bill creation`;
//   } else if (missingBilling.length) {
//     warningMessage = `Add ${missingBilling.join(", ")} in Billing Address to proceed with E-Way Bill creation`;
//   } else if (missingShipping.length) {
//     warningMessage = `Add ${missingShipping.join(", ")} in Shipping Address to proceed with E-Way Bill creation`;
//   }

//   if (warningMessage) {
//     showWarningSnackbar(warningMessage);
//     return false;
//   }
//   return true;
// }
function checkEwayBillAddress() {
  if (!eWayImp ) return true;

  const isPresent = (v) => {
    if (v == null) return false;
    if (typeof v === "string") return v.trim().length > 0;
    if (typeof v === "object") {
      const label = v.label ? v.label.trim() : "";
      const value = v.value ? v.value.trim() : "";
      const code  = v.code  ? v.code.trim()  : "";
      return !!(label || value || code);
    }
    return !!v;
  };

  const anyKeyPresent = (obj, keys) => keys.some((k) => isPresent(obj?.[k]));

  const FIELDS_MAP = {
    Billing: [
      { keys: ["billingAddress", "addressLine", "address"], label: "Address Details" },
      { keys: ["district", "districtName"],                  label: "District" },
      { keys: ["pincode", "pinCode", "postalCode", "zip", "zipcode"], label: "Pincode" },
      { keys: ["states", "state", "province"],               label: "State" },
      { keys: ["city", "town"],                              label: "City" },
      { keys: ["country"],                                   label: "Country" },
    ],
    Shipping: [
      { keys: ["deliveryAddress", "shippingAddress", "address"], label: "Address Details" },
      { keys: ["district", "districtName"],                      label: "District" },
      { keys: ["pincode", "pinCode", "postalCode", "zip", "zipcode"], label: "Pincode" },
      { keys: ["states", "state", "province"],                   label: "State" },
      { keys: ["city", "town"],                                  label: "City" },
      { keys: ["country"],                                       label: "Country" },
    ],
  };

  const getMissingLabels = (details, type) =>
    FIELDS_MAP[type]
      .filter(({ keys }) => !anyKeyPresent(details, keys))
      .map(({ label }) => label);

  const fmt = (arr) => arr.join(", ");
  const isAllMissingOrOnlyCountry = (missing) =>
    missing.length === 6 || (missing.length === 5 && !missing.includes("Country"));
  const missingBilling  = getMissingLabels(billingAddressDetails, "Billing");
  const missingShipping = getMissingLabels(deliveryAddressDetails, "Shipping");

  const messages = [];


  if (eWayImp) {
    const billingAll  = isAllMissingOrOnlyCountry(missingBilling);
    const shippingAll = isAllMissingOrOnlyCountry(missingShipping);

    if (billingAll && shippingAll) {
      messages.push("Add Billing Address & Ship To Address to proceed with E-Way Bill creation");
    } else if (billingAll && missingShipping.length === 0) {
      messages.push("Add Billing Address to proceed with E-Way Bill creation");
    } else if (shippingAll && missingBilling.length === 0) {
      messages.push("Add Ship To Address to proceed with E-Way Bill creation");
    } else {
      const hasBilling  = missingBilling.length  > 0;
      const hasShipping = missingShipping.length > 0;

      if (hasBilling && hasShipping) {
        messages.push(
          `Fill ${fmt(missingBilling)} in Billing Address, Fill ${fmt(missingShipping)} in Ship To Address to proceed with E-Way Bill creation`
        );
      } else if (hasBilling) {
        messages.push(`Fill ${fmt(missingBilling)} in Billing Address to proceed with E-Way Bill creation`);
      } else if (hasShipping) {
        messages.push(`Fill ${fmt(missingShipping)} in Ship To Address to proceed with E-Way Bill creation`);
      }
      
    }
  }

  

  if (messages.length) {
    showWarningSnackbar(messages.join("\n"));
    return false;
  }
  return true;
}




   function checkPriceTypeWithInvDate(value) {
      const updatedTableArr = [...items];
      let isValid = true;
  
      const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
      updatedTableArr.forEach((subele) => {
        if (subele?.effectiveFrom !== 0) {
          const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
          const tempEffectiveTo =
            subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');
  
          const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
          const isOutsideRange =
            normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));
  
          if (isOutsideRange) {
            isValid = false;
            subele.invalidDate = true;
          } else {
            subele.invalidDate = false;
          }
        }
      });
  
      if (!isValid) {
        showWarningSnackbar('The highlighted items do not match the entry date range. Please verify the effective dates.');
      }
      return isValid;
    }
  async function getPurchaseMasterData(data) {
    try {
      // setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getPurchaseMasterCustom, { purchaseid: data }));
      if (res.data.getPurchaseMaster !== null) {
        setInvoiceEntry(res.data.getPurchaseMaster?.[0]);
             
                                                               
      const invDate=  res.data.getPurchaseMaster?.[0].entrydate;
      setSavedPostingDate(invDate);
        
        // setBackdropOpen(false);
      }else{
        setSavedPostingDate("");
        setData((prev)=>({
          ...prev,
          invoiceDate:"",
        }));
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  let url = path + `Invoices/Purchase/Ledgerx_Purchase_Invoice_${data.voucherNumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;
  function showEInvAuthModal(connectCheckbox) {
    setBackdropOpen(false);
    return new Promise((resolve) => {
      setConnectCheckbox(connectCheckbox);
      setEInvAuthModalProps({
        open: true,
        onComplete: (result) => resolve(result),
      });
    });
  }
  const [createPdf, progress] = useCreatePdfMutation();
  async function saveChanges(obj) {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;
    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };

    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2 
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2 &&  partyType === 'CUSTOMER'
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
       if (isvalid) {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
          if (isvalid) {
  if (!checkEwayBillAddress()) {
    setBackdropOpen(false);
    isvalid=false;
  }
}
      if (isvalid) {
        try {
          const comments = data.remarks;
          let invMasterArr = [];
          let invDispatchArr = [];
          let tdsArr = [];
          let invLineItemArr = [];
          let invNonLineItemArr = [];
          let tcsArr = [];
          let invAddArr = [];
          let invTransactionArray = [];
          let invLineGstArr = [];
          let invLineNonGstArr = [];
          let randomNum = Math.floor(Math.random() * 100 + 1);
          let timeStamp = Math.floor(new Date().getTime() / 1000);
          let randomNumber = randomNum + timeStamp.toString().slice(3, 10);

          const invMasterData = {
            purchasegsttypecd: String(taxability?.value),
            supplierid: Number(partyName.value),
            entrydate: Math.floor(new Date(invoiceDate).getTime() / 1000),
            vouchernumber: String(voucherNumber === '' ? 0 : voucherNumber),
            supplierinvoicedate: data.customerOrderDate ? Math.floor(new Date(data.customerOrderDate).getTime() / 1000) : 0,
            supplierinvoicenumber: String(data.orderNumber),
            supplieraddressid: 10,
            paymenttypecd: String(paymentType),
            paidamount: Number(receivedAmount),
            creditduration: isNaN(Number(creditPeriod)) ? 0 : Number(creditPeriod),
            paymentaccountid: receivedAccount.value === '' ? 0 : Number(receivedAccount.value),
            comments: String(comments),
            tdsapplicableflag: 0,
            granttotalamount: Number(netAmountToPay),
            balancedueamount: Number(data.balanceDueAmt),
            paymentclearedflag: Number(data.balanceDueAmt === 0 ? 1 : 0),
            placeofsupply: String(placeOfSupply.value),
            companystate: String(companyState),
            roundoffamount: Number(data.roundOff),
            discounttype: Number(data.adjustmentsType),
            discountvalue: Number(data.adjustmentsValue),
            adjustmentamount: Number(adjustments),
            // serialnumber: String(data.seriesVouchers.value),
             serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
            currencycode: String(data.currency.value),
            currencyrate: Number(data.currencyRate),
            reversechargeflag: Number(data.reverseChargeFlag),
            partyregistrationtype: String(data.partyCategory),
            purchaseinvoicepdf: String(uri),
            consigneename: String(data.consigneeName !== '' ? data.consigneeName : ''),
            consigneegstin: String(
              data.consigneeGST !== '' && data.consigneeGST !== undefined && data.consigneeGST !== null ? data.consigneeGST : ''
            ),
            transactiontypecd: String('PurchaseInvoice'),
            bankreferencenumber: String(paymentType === 'Bank' ? data?.bankReferenceNo : ''),
            itcflag:Number(data?.ITCFlag)
          };

          invMasterArr.push(invMasterData);
          if (items.length > 0) {
            items.map((ele, index) => {
              if (ele?.itemCode?.value !== '') {
                const lineItem = {
                  purchaseitemid: Number(index + 1),
                  itemnumber: Number(index + 1),
                  itemid: Number(ele.name.value),
                  purchaseaccountid: Number(ele.ledgerAccount.value),
                  hsncode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  itemquantity: Number(ele.qty),
                  unittypecd: String(ele.units),
                  itemrate: Number(ele.rate),
                  itemamount: Number(ele.amount),
                  itemdiscount: Number(ele.dicount),
                  netamount: Number(ele.netAmount),
                  taxability: String(data?.taxability.value),
                  pricetype: String(ele?.priceType?.label),
                  manualdiscount: Number(ele?.manualDiscount === true ? 1 : 0),
                  pricetypeid: Number(0),
                  itemtype: String(ele.itemType),
                  manualgst:Number(ele?.manualGSTFlag),
                  manualcess: Number(ele?.manualCess),
                   discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
                 
                };

                invLineItemArr.push(lineItem);
                const gstData = {
                  purchaseitemid: Number(index + 1),
                  gstrate: Number(ele.GSTRate),
                  cessamount: Number(ele.GSTCess),
                  gstamount: Number(ele.IGST),
             
                  cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType),
                  // gsttypecd: String(""),
                };

                invLineGstArr.push(gstData);
              }
            });
          }
          if (nonItems.length > 0) {
            nonItems.map((ele, index) => {
              if (ele?.ledgerAccount?.value !== '') {
                const lineNonItem = {
                  purchaseitemid: Number(index + 1),
                  purchaselineitemtype: String('NONITEM'),
                  purchaseaccountid: Number(ele.ledgerAccount.value),
                  hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  itemdescription: String(ele.description),
                  taxableamount: Number(ele.taxableAMount),
                  netamount: Number(ele.netAmount),
                  taxability: String(data?.taxability.value),
                  manualgst:Number(ele?.manualGSTFlag),
                  manualcess: Number(ele?.manualCess),
                };

                invNonLineItemArr.push(lineNonItem);
                const gstData = {
                  purchaseitemid: Number(index + 1),
                  gstrate: Number(ele.GSTRate),
                  cessamount: Number(ele.GSTCess),
                  gstamount: Number(ele.IGST),
                  cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType),
                  // gsttypecd: String(""),
                };

                invLineNonGstArr.push(gstData);
              }
            });
          }
          const tcsData = {
            tcsapplicablecd: String(data.tcsFlag === '' ? 0 : data.tcsFlag),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: Number(data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag),
            reversechargeflag: Number(data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tcsamount: Number(data.tcsAmount),
            adjustmentamount: Number(data.adjustments),
            tcssection: String(data.tcsOptions),
            tcspercentage: Number(data.tcsPercent),
            tcsmanual: Number(data.manualTcsFlag),
          };

          tcsArr.push(tcsData);
          const tdsData = {
            tdsapplicablecd: String(0),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: Number(data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag),
            reversechargeflag: Number(data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tdsamount: Number(data.tdsAmount),
            adjustmentamount: Number(data.adjustments),
            tdssection: String(data.tdsOptions),
            tdspercentage: Number(data.tdsPercent),
            tdsmanual: Number(data.manualTdsFlag),
          };

          tdsArr.push(tdsData);
          if (isAdrressEmpty) {
            let add =
              deliveryAddressDetails.deliveryAddress !== ''
                ? deliveryAddressDetails.deliveryAddress
                : "";
            const addressDetails = {
              consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
              consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
              objecttype: String('PurchaseDelivery'),
              line1: String(add),
              line2: String(''),
              line3: String(''),
              city: String(
                 deliveryAddressDetails.city?.value ?? '',
              
              ),
              statecode: Number(
                deliveryAddressDetails.states ?? 0
              ),
              pincode: String(
                deliveryAddressDetails.pincode ?? ''
              ),
              countrycode: String(
                deliveryAddressDetails.country  ?? ''
              ),
              district: String(
                deliveryAddressDetails.district  ?? ''
              ),
              foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
            };

            invAddArr.push(addressDetails);
          }

          let billAdd =
            billingAddressDetails.billingAddress !== ''
              ? billingAddressDetails.billingAddress
              : "";
          const billaddressDetails = {
            consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
            consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
            objecttype: String('PurchaseBilling'),
            line1: String(billAdd),
            line2: String(''),
            line3: String(''),
            city: String(
            billingAddressDetails.city.value ??
            '',
            ),
            statecode: Number(
              billingAddressDetails.states  ?? ''
            ),
            pincode: String(
              billingAddressDetails.pincode ?? ''
            ),
            countrycode: String(
              billingAddressDetails.country  ?? ''
            ),
            district: String(
              billingAddressDetails.district  ?? ''
            ),
            foreignstate:String(billingAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
          };

          invAddArr.push(billaddressDetails);
          invTransArr.map((ele, ind) => {
            // let obj = {
            //   accountid: ele.accID,
            //   comments: data.remarks,
            //   debitamount: Number(ele.debitAmt).toFixed(2),
            //   creditamount: Number(ele.creditAmt).toFixed(2),
            //   entryordernumber: ind + 1,
            //   transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
            // };
            let obj = {
              transactiontypecd: String(Number(ele.debitAmt) !== 0 ? 'Debit' : 'Credit'),
              accountid: Number(ele.accID),
              creditamount: Number(Number(ele.creditAmt).toFixed(2)),
              debitamount: Number(Number(ele.debitAmt).toFixed(2)),
              comments: String(data.remarks),
              // entryordernumber: Number(ind + 1),
            };

            invTransactionArray.push(obj);
          });
          // const attachedArr = itemsRows.map((ele) => ({
          //   documentname: ele.documentname,
          //   attachmentname: ele.imagename,
          //   attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
          //   type: ele?.type,
          // }));
          const attachedArr = itemsRows.map((ele) => ({
            attachmentname: String(ele.imagename),
            attachmenturl: String(`${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`),
            documentname: String(ele.documentname),
            type: String(ele?.type),
          }));

          const resPurchaseInvoice = await API.graphql(
            graphqlOperation(createPurchaseInvoice, {
              createPurchaseInvoiceInput: {
                purchaselinegst: invLineGstArr,
                purchaselineitems: invLineItemArr,
                purchaselinenonitems: invNonLineItemArr,
                purchaselinenongst: invLineNonGstArr,
                purchasetcsdetails: tcsArr,
                purchasetdsdetails: tdsArr,
                purchasetransactionmaster: invMasterArr,
                partyaddressentity: invAddArr,
                transactiondetails: invTransactionArray,
                purchaseattachment: attachedArr,
              },
            })
          );

          if (resPurchaseInvoice.data.createPurchaseInvoice !== null) {
            let responses = itemsRows.map((element) => {
              if (element.file) {
                return uploadToServer(
                  element.file,
                  element.imagename.replace('${id}', resPurchaseInvoice.data.createPurchaseInvoice.purchaseid),
                  element.type
                );
              }
            });
            await Promise.all(responses);
            await savePaymentDetails(resPurchaseInvoice.data.createPurchaseInvoice.purchaseid);
            setBackdropOpen(true);
            dispatch(setNavigationBlocked(false));
            dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock',"bizview"]));
            showSuccessSnackbar('Purchase generated successfully');

            createPdf({
              companyid: companyData?.companyid,
              path: url,
              invoiceids: resPurchaseInvoice.data.createPurchaseInvoice.purchaseid,
              type: 'purchaseInvoice',
            });
            const partyBilling =
              partyBillAddressEntity.district !== '' &&
              partyBillAddressEntity.line1 !== '' &&
              partyBillAddressEntity.pincode !== '' &&
              partyBillAddressEntity.statecode !== '';
            const partyDelivery =
              partyDeliveryAddressEntity.district !== '' &&
              partyDeliveryAddressEntity.line1 !== '' &&
              partyDeliveryAddressEntity.pincode !== '' &&
              partyDeliveryAddressEntity.statecode !== '';
          
            if (obj.new == false) {
              if (eWayImp === true) {
                if (partyBilling === false && partyDelivery === false) {
                  showWarningSnackbar('Please add/complete billing and delivery address for party to create e way bill');
                  navigate('/allpurchaseandexpense');
                } else if (partyBilling === false && partyDelivery === true) {
                  showWarningSnackbar('Please add/complete billing address for party to create e way bill');
                  navigate('/allpurchaseandexpense');
                } else if (partyBilling === true && partyDelivery === false) {
                  showWarningSnackbar('Please add/complete delivery address for party to create e way bill');
                  navigate('/allpurchaseandexpense');
                }
                if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect === 0) {
                  setConnectCheckbox('eway');
                  let result;
                  do {
                    result = await showEInvAuthModal('eway');
                  } while (result !== 'success');
                  showSuccessSnackbar('Validated successfully');
                  ewayNav(data, resPurchaseInvoice.data.createPurchaseInvoice.purchaseid, Number(partyName.value), false);
                } else {
                  setTimeout(() => {
                    ewayNav(data, resPurchaseInvoice.data.createPurchaseInvoice.purchaseid, Number(partyName.value), false);
                  }, 1000);
                }
              } else {
                // Set email data for sharing
                setIndividualEmailSelection([
                  {
                    PartyID: Number(partyName.value),
                    Email: data?.partyEmail || '',
                    PartyDisplayName: data?.partyName?.label || '',
                    invoiceid: resPurchaseInvoice.data.createPurchaseInvoice.purchaseid,
                    invoicenumber: data?.voucherNumber || '',
                  },
                ]);
                // setShareOpen(url);
                navigate('/allpurchaseandexpense');
                setBackdropOpen(false);
              }
            } else {
              // window.location.reload();
              setBackdropOpen(false);
              setData((prev) => ({
                ...resetData,
                invoiceDate: prev?.invoiceDate,
                customerOrderDate: prev?.customerOrderDate,
              }));
              getLastPurchaseInvoice();
              // getVoucherDetails("Payment");
              dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'PurchaseInvoice' }]));
              dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
              setNonItems([resetNonItems]);
              setItems([resetItems]);
              setItemValid(true);
              setNonItemValid(true);
              setItemsRows([]);
              createPdf({
                companyid: companyData?.companyid,
                path: url,
                invoiceids: resPurchaseInvoice.data.createPurchaseInvoice.purchaseid,
                type: 'purchaseInvoice',
              });
            }
          } else {
            setBackdropOpen(false);

            showErrorSnackbar(resPurchaseInvoice.data.createPurchaseInvoice.StatusMessage);
          }
        } catch (error) {
          setBackdropOpen(false);
          const rawMessage = error.errors[0].message?.split('RDSHttp:')[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          const errorMessage = parsedMessage?.split('ERROR: ')[1]?.split(';')[0];
          showWarningSnackbar(errorMessage);
          console.log('error', error);
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  async function saveEditChanges() {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };

    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push('Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2 && partyType === 'CUSTOMER'
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid) {
        try {
          const comments = data.remarks;
          const invMasterData = {
            purchaseinvoicepdf: invoiceEntry?.purchaseinvoicepdf,
            adjustmentamount: Number(adjustments),
            balancedueamount: Number(data.balanceDueAmt),
            comments: comments,
            creditduration: isNaN(Number(creditPeriod)) ? 0 : Number(creditPeriod),
            expiredtimestamp: 0,
            entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
            granttotalamount: Number(netAmountToPay),
            paidamount: data?.paymentDeletionFlag === true ? 0 : Number(receivedAmount),
            paymentaccountid: receivedAccount.value === '' ? 0 : receivedAccount.value,
            paymentclearedflag: 0,
            paymenttypecd: paymentType,
            purchasegsttypecd: String(taxability?.value),
            purchaseid: invoiceEntry?.purchaseid,
            placeofsupply: String(placeOfSupply.value),
            supplieraddressid: 10,
            supplierid: partyName.value,
            supplierinvoicedate: data.customerOrderDate ? Math.floor(new Date(data.customerOrderDate).getTime() / 1000) : 0,
            supplierinvoicenumber: data.orderNumber,
            tdsapplicableflag: 0,
            vouchernumber:  voucherNumber===""?String(data.seriesVouchers.label):String(voucherNumber),
            // serialnumber: data.seriesVouchers.value,
             serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
            companystate: String(companyState),
            discounttype: data.adjustmentsType,
            discountvalue: Number(data.adjustmentsValue),
            roundoffamount: Number(data.roundOff),
            currencycode: data.currency.value,
            currencyrate: data.currencyRate,
            reversechargeflag: data.reverseChargeFlag,
            partyregistrationtype: data.partyCategory,
            cancelremark: '',
            deleteremark: '',
            financialyearid: userPreferece?.financialYear?.financialyearid,
            cancelflag: 0,
            paymentstatus: 0,
            companybranchid: 0,
            partydisplayname: data?.partyName?.label,
            consigneename: data.consigneeName !== '' ? data.consigneeName : '',
            consigneegstin:
              data.consigneeGST !== '' && data.consigneeGST !== undefined && data.consigneeGST !== null ? data.consigneeGST : '',
                itcflag:Number(data?.ITCFlag)
          };

          updatePurchaseMasterData(invMasterData);
        } catch (error) {
          setBackdropOpen(false);
          console.log('error', error);
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  // async function updatePurchaseMasterData(invMasterData) {
  //   try {
  //     const res = await API.graphql(
  //       graphqlOperation(updatePurchaseMaster, {
  //         updatePurchaseMasterInput: invMasterData,
  //       })
  //     );
  //     if (res.data?.updatePurchaseMaster.StatusCode === "Error") {
  //       showWarningSnackbar(res.data?.updatePurchaseMaster.StatusMessage);
  //     } else {
  //       const promises = [
  //         updatePaymentDetails(res.data?.updatePurchaseMaster.PurchaseID),
  //         updateItemEntry(res.data?.updatePurchaseMaster.PurchaseID),
  //         updateTDSDetails(res.data?.updatePurchaseMaster.PurchaseID),
  //         updateTCSDetails(res.data?.updatePurchaseMaster.PurchaseID),
  //         updateAddressDetails(res.data?.updatePurchaseMaster.PurchaseID),
  //         saveLinkTranSaction(res.data?.updatePurchaseMaster.PurchaseID),
  //         updatePurchaseTransactionDetails(
  //           invoiceEntry?.RelatedPurchaseTransactionDetails[0]?.TransactionID
  //         ),
  //         addAttachmets(res.data?.updatePurchaseMaster.PurchaseID),
  //       ];
  //       // if (invoiceEntry?.RelatedPurchaseAttachment?.length > 0) {
  //       //   const deleteAttach = await API.graphql(
  //       //     graphqlOperation(deletePurchaseAttachment, {
  //       //       PurchaseID: invoiceEntry?.PurchaseID,
  //       //     })
  //       //   );
  //       //   if (deleteAttach.data.deletePurchaseAttachment !== null) {
  //       //     addAttachmets(res.data?.updatePurchaseMaster.PurchaseID);
  //       //   }
  //       // } else {

  //       // }
  //       await Promise.all(promises);
  //       setBackdropOpen(false);
  //       showSuccessSnackbar("Purchase updated successfully");
  //       navigate("/allpurchaseandexpense");
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }
  async function updatePurchaseMasterData(invMasterData) {
    try {
      let itemArr = [];
      let gstArr = [];
      let nonItemArr = [];
      let nonGstArr = [];
      let invTransactionArray = [];
      let invAddArr = [];
      let currentMaxPurchaseItemId = Math.max(
  0,
  ...[...items, ...deletedItems]
    .map((ele) => Number(ele?.purchaseitemid || 0))
    .filter((id) => !isNaN(id))
);
      [...items, ...deletedItems]?.map(async (ele, index) => {
        if (ele?.itemCode?.value !== '') {
              if (!ele?.purchaseitemid) {
      currentMaxPurchaseItemId += 1;
      ele.purchaseitemid = currentMaxPurchaseItemId;
    }

          const lineItemsData = {
            hsncode: String(ele?.HSN?.value === '' ? 0 : ele?.HSN?.value),
            itemamount: ele.amount,
            itemdiscount: Number(ele.dicount),
            taxability: data?.taxability?.value,
            itemid: ele.name.value,
            itemname: ele?.name?.label,
            itemnumber: 10,
            itemquantity: Number(ele.qty),
            pricetype: ele?.priceType?.label,
            pricetypeid: 0,
            itemrate: Number(ele.rate),
            netamount: ele.netAmount,
            purchaseaccountid: ele?.ledgerAccount?.value == '' ? 0 : ele?.ledgerAccount?.value,
            purchaseid: invoiceEntry?.purchaseid,
            purchaseitemid: ele?.purchaseitemid ?ele?.purchaseitemid:index+1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            unittypecd: ele.units,
            lotid: '',
            companybranchid: 0,
            manualdiscount: ele?.manualDiscount === true ? 1 : 0,
            manualcess: Number(ele?.manualCess),
            itemtype: String(ele.itemType),
            entrydate: Math.floor(new Date(data?.invoiceDate).getTime() / 1000),
            manualgst:Number(ele?.manualGSTFlag),
             discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
          };
          itemArr.push(lineItemsData);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            // gstamount: (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100,
              gstamount:Number(ele?.IGST),
            gstrate: Number(ele.GSTRate),
            purchaseid: invoiceEntry?.purchaseid,
            purchaseitemid: ele?.purchaseitemid ? ele?.purchaseitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
                  cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType),
          };
          gstArr.push(gstData);
        }
      });
  let currentMaxPurchaseNonItemId = Math.max( 0, ...[...items, ...deletedItems]
    .map((ele) => Number(ele?.purchaseitemid || 0))
    .filter((id) => !isNaN(id))
);
      [...nonItems, ...deletedNonItems].map(async (ele, index) => {
        if (ele?.ledgerAccount?.value !== '') {
                 if (!ele?.purchaseitemid) {
      currentMaxPurchaseNonItemId += 1;
      ele.purchaseitemid = currentMaxPurchaseNonItemId;
    }
          const nonItemsData = {
            hsnsaccode: String(ele?.HSN?.value == '' ? 0 : ele?.HSN?.value),
            itemdescription: ele.description,
            netamount: ele.netAmount,
            purchaseaccountid: ele?.ledgerAccount?.value,
            taxability: data?.taxability?.value,
            purchaseid: invoiceEntry?.purchaseid,
            purchaseitemid: ele?.purchaseitemid ? ele?.purchaseitemid : index + 1,
            purchaselineitemtype: 'NONITEMS',
            taxableamount: Number(ele.taxableAMount),
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
            manualgst:Number(ele?.manualGSTFlag),
            manualcess:Number(ele?.manualCess)
          };
          nonItemArr.push(nonItemsData);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            // gstamount: (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100,
              gstamount:Number(ele?.IGST),
            gstrate: Number(ele.GSTRate),
            purchaseid: invoiceEntry?.purchaseid,
            purchaseitemid: ele?.purchaseitemid ? ele?.purchaseitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
            cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType),
          };
          nonGstArr.push(gstData);
        }
      });
      const tdsData = {
        adjustmentamount: Number(data.adjustments),
        companybranchid: 0,
        expiredtimestamp: 0,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        purchaseid: invoiceEntry?.purchaseid,
        reversechargeflag: data.reverseChargeFlag,
        tdsamount: Number(data.tdsAmount),
        tdsapplicablecd: 0,
        tdssection: data.tdsOptions,
        tdsmanual: data.manualTdsFlag,
        tdspercentage: Number(data.tdsPercent),
        totaltaxableamount: Number(totTaxAmt),
      };

      const tcsData = {
        adjustmentamount: Number(data.adjustments),
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        purchaseid: invoiceEntry?.purchaseid,
        reversechargeflag: data.reverseChargeFlag,
        tcsamount: Number(data.tcsAmount),
        tcsapplicablecd: data.tcsFlag === '' ? 0 : data.tcsFlag,
        tcssection: data.tcsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tcspercentage: Number(data.tcsPercent),
        tcsmanual: data.manualTcsFlag,
        companybranchid: 0,
        expiredtimestamp: 0,
      };
      if (isAdrressEmpty) {
        let add =
          deliveryAddressDetails?.deliveryAddress !== ''
            ? deliveryAddressDetails?.deliveryAddress
            : "";
        const addressDetails = {
            consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
            consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),

          city:
           deliveryAddressDetails.city?.value  ?? '',

          countrycode:
            deliveryAddressDetails.country ?? '',

          line1: add,
          line2: '',
          line3: '',
          objectid: invoiceEntry?.purchaseid,
          objecttype: 'PurchaseDelivery',

          pincode:
            deliveryAddressDetails.pincode ??'',

          statecode:
            deliveryAddressDetails?.states?? 0,

          district:
            deliveryAddressDetails.district ?? '',

          expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid,
          foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
        };
        invAddArr.push(addressDetails);
      }else{
        
        const addressDetails = {
            consigneename: String(''),
            consigneegstin: String(''),

          city:
           '',

          countrycode:
            '',

          line1: '',
          line2: '',
          line3: '',
          objectid: invoiceEntry?.purchaseid,
          objecttype: 'PurchaseDelivery',

          pincode:
            '',

          statecode:
           0,

          district:
            '',

          expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid,
          foreignstate:String(''),
              foreigndistrict:String('')
        };
        invAddArr.push(addressDetails);
      }
      let billAdd =
        billingAddressDetails?.billingAddress !== ''
          ? billingAddressDetails?.billingAddress
          : "";
      const billaddressDetails = {
        



  consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
            consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
        city:
          billingAddressDetails.city.value ??
             '',

        countrycode:
          billingAddressDetails.country ?? '',

        line1: billAdd,
        line2: '',
        line3: '',
        objectid: invoiceEntry?.purchaseid,
        objecttype: 'PurchaseBilling',

        pincode:
          billingAddressDetails.pincode??'',

        statecode:
          billingAddressDetails.states??0,

        district:
          billingAddressDetails.district ?? '',

        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        foreignstate:String(billingAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
      };
      invAddArr.push(billaddressDetails);
      invTransArr.map((ele, ind) => {
        let obj = {
          accountid: Number(ele.accID),
          comments: data.remarks,
          debitamount: Number(ele.debitAmt).toFixed(2),
          creditamount: Number(ele.creditAmt).toFixed(2),
          // entryordernumber: ind + 1,
          transactionid: Number(invoiceEntry?.relatedpurchasetransactiondetails[0]?.transactionid),
          transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
          enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          cancelflag: 0,
        };

        invTransactionArray.push(obj);
      });
      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(itemsRows.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          arr = itemsRows.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = itemsRows.filter((item2) => !currentDouments.some((item1) => item1.attachmentid == item2.attachmentid));

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele) => ({
        attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
        purchaseid: invoiceEntry?.purchaseid,
        documentname: ele.documentname,
        attachmentname: ele.imagename,
        attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename.replace('${id}', invoiceEntry?.purchaseid)}`,
        type: ele?.type,
        companybranchid: 0,
        expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
      }));
      if (attachedArr?.length > 0) {
        let responses = itemsRows.map((element) => {
          if (element.file) {
            return uploadToServer(element.file, element.imagename.replace('${id}', invoiceEntry?.purchaseid), element.type);
          }
        });
      }
      await Promise.all(attachedArr);
      let variables = {};
      if (attachedArr?.length > 0) {
        variables = {
          createPurchaseMasterInput: invMasterData,
          createPurchaseLineItemsInput: itemArr,
          createPurchaseLineNonItemsInput: nonItemArr,
          createPurchaseLineNonGSTInput: nonGstArr,
          createPurchaseLineGSTInput: gstArr,
          createPurchaseTDSDetailsInput: [tdsData],
          createPurchaseTCSDetailsInput: [tcsData],
          createPartyAddressEntityInput: [billaddressDetails],
          createPurchaseAttachmentInput: attachedArr,
          createTransactionWithSpecificTimeInput: {
            transactionmaster: [],
            transactiondetails: invTransactionArray,
            transactionattachment: [],
            transactiontdsdetails: [],
            transactionrelation: [],
            mode: 0,
            transactiontcsdetails: [],
          },
        };
      } else {
        variables = {
          createPurchaseMasterInput: invMasterData,
          createPurchaseLineItemsInput: itemArr,
          createPurchaseLineNonItemsInput: nonItemArr,
          createPurchaseLineNonGSTInput: nonGstArr,
          createPurchaseLineGSTInput: gstArr,
          createPurchaseTDSDetailsInput: [tdsData],
          createPurchaseTCSDetailsInput: [tcsData],
          createPartyAddressEntityInput: invAddArr,
          createTransactionWithSpecificTimeInput: {
            transactionmaster: [],
            transactiondetails: invTransactionArray,
            transactionattachment: [],
            transactiontdsdetails: [],
            transactionrelation: [],
            mode: 0,
            transactiontcsdetails: [],
          },
        };
      }
      const response = await API.graphql(
        graphqlOperation(attachedArr?.length > 0 ? createPurchaseBatch : createPurchaseBatchWithoutImages, variables)
      );

      await updatePaymentDetails(response?.data?.createPurchaseMaster?.purchaseid);
      console.log(response.data.createPurchaseMaster.purchaseid, response);
      let voucherName = `Ledgerx_Purchase_Invoice_${data?.voucherNumber}.pdf`;
      createPdf({
        companyid: companyData?.CompanyID,
        path: `${path}Invoices/Purchase/${voucherName}`,
        invoiceids: response.data.createPurchaseMaster.purchaseid,
        type: 'purchaseInvoice',
      });
      dispatch(setNavigationBlocked(false));
      dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock',"bizview"]));
      setBackdropOpen(false);
      showSuccessSnackbar('Purchase updated successfully');
      navigate('/allpurchaseandexpense');
      // }
    } catch (error) {
      console.log('error', error);
      const errorMessage = error.errors?.[0]?.message;
      showErrorSnackbar(errorMessage);
      setBackdropOpen(false);
    }
  }

  async function updatePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let linkedArr = [];
      const comments = data?.remarks?.split('\n');
      if (data.paymentType !== 'Credit') {
        if (paymentTransID !== '') {
          const masterData = {
            transactionid: paymentTransID,
            bankreferencenumber: data.bankReferenceNo,
            entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
            comments: comments?.join('**'),
            vouchernumber: data.transactionVoucher,
            serialnumber: data.transactionSeries.value,
            transactiontypecd: data.paymentType == 'Cash' ? 'CashPayment' : data.paymentType == 'Bank' ? 'BankPayment' : 'Credit',
            cancelflag: 0,
          };

          paymentTransArr.map((ele, index) => {
            const paymentTransDetails = {
              accountid: ele.accID,
              comments: comments?.join('**'),
              creditamount: Number(ele.creditAmt).toFixed(2),
              debitamount: Number(ele.debitAmt).toFixed(2),
              entryordernumber: index + 1,
              transactionid: paymentTransID,
              transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
              enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
              cancelflag: 0,
            };
            tranSDetailsArr.push(paymentTransDetails);
          });

          const linkCurrentPayment = {
            linkedamount: data.receivedAmount,
            transactiontypecd: 'PurchaseInvoice',
            isdirect: 1,
            objectattribute: data.voucherNumber,
            objectid: invID,
            objecttype: data.paymentType,
            transactionid: paymentTransID,
            accountid: partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
            expiredtimestamp: 0,
          };
          linkedArr.push(linkCurrentPayment);
          linkedTransArr.map(async (ele) => {
            let linkTransData = {
              linkedamount: ele.linkedamount,
              transactiontypecd: 'PurchaseInvoice',
              isdirect: 0,
              objectattribute: data?.voucherNumber,
              objectid: invID,
              objecttype: ele.transactiontypecd,
              transactionid: ele.transactionid,
              accountid: partyAccountID,
              paymentvouchernumber: data?.transactionVoucher,
              expiredtimestamp: 0,
            };
            linkedArr.push(linkTransData);
          });

          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTime, {
              transactionmaster: JSON.stringify([masterData]),
              transactiondetails: JSON.stringify(tranSDetailsArr),
              transactionattachment: JSON.stringify([]),
              transactiontdsdetails: JSON.stringify([]),
              transactionrelation: JSON.stringify(linkedArr),
              mode: 0,
              transactiontcsdetails: JSON.stringify([]),
            })
          );

          let url = path + `Invoices/Payments/Ledgerx_Payment_${data?.transactionVoucher}.pdf`;
          await createPdf({
            path: url,
            type: 'payment',
            transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
          });
        } else {
          savePaymentDetails(invID);
        }
      } else {
        if (paymentTransID !== '' && data?.paymentDeletionFlag === true) {
          const deleteTransMaster = await API.graphql(
            graphqlOperation(deleteTransactionMaster, {
              transactionid: paymentTransID,
            })
          );
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  async function savePaymentDetails(invID) {
    try {
      let masterArr = [];
      let linkedArr = [];
      let tranSDetailsArr = [];
      const comments = data?.remarks?.split('\n');
      if (data.paymentType !== 'Credit') {
        const masterData = {
          bankreferencenumber: data.bankReferenceNo,
          comments: comments?.join('**'),
          entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          transactiontypecd: data.paymentType == 'Cash' ? 'CashPayment' : data.paymentType == 'Bank' ? 'BankPayment' : 'Credit',
          vouchercode: transGeneralSettingsFlag === -1 ? data.transactionVoucher : '',
          serialnumber: data.transactionSeries.value,
          cancelflag: 0,
        };
        masterArr.push(masterData);

        paymentTransArr.map((ele, index) => {
          const paymentTransDetails = {
            accountid: ele.accID,
            comments: comments?.join('**'),
            creditamount: Number(ele.creditAmt).toFixed(2),
            debitamount: Number(ele.debitAmt).toFixed(2),
            entryordernumber: index + 1,

            transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
            cancelflag: 0,
          };
          tranSDetailsArr.push(paymentTransDetails);
        });

        const linkCurrentPayment = {
          linkedamount: data.receivedAmount,
          transactiontypecd: 'PurchaseInvoice',
          isdirect: 1,
          objectattribute: data.voucherNumber,
          objectid: invID,
          objecttype: data.paymentType,

          accountid: partyAccountID,
          paymentvouchernumber: data?.transactionVoucher,
        };
        linkedArr.push(linkCurrentPayment);
        linkedTransArr.map(async (ele) => {
          let linkTransData = {
            linkedamount: ele.linkedamount,
            transactiontypecd: 'PurchaseInvoice',
            isdirect: 0,
            objectattribute: data?.voucherNumber,
            objectid: invID,
            objecttype: ele.transactiontypecd,
            transactionid: ele.transactionid,
            accountid: partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
          };
          linkedArr.push(linkTransData);
        });
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTime, {
            transactionmaster: JSON.stringify(masterArr),
            transactiondetails: JSON.stringify(tranSDetailsArr),
            transactionattachment: JSON.stringify([]),
            transactiontdsdetails: JSON.stringify([]),
            transactionrelation: JSON.stringify(linkedArr),
            mode: 1,
            transactiontcsdetails: JSON.stringify([]),
          })
        );

        let url = path + `Invoices/Payments/Ledgerx_Payment_${data?.transactionVoucher}.pdf`;
        await createPdf({
          path: url,
          type: 'payment',
          transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
        });
        return result;
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        element?.focus();
      }
    }
  }, [errorArr]);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);

      element?.focus();
    }
  }, [tableErrArr]);
  useEffect(() => {
    let id = 'partyName';
    if (params?.id) {
      getPurchaseMasterData(params?.id);
      setViewMode(params?.view);
    } else {
      setBackdropOpen(false);
    }
    if (!params?.id) {
      let element = document?.getElementById(id);
      element?.focus();
    }
  }, []);

 async function getLastPurchaseInvoice() {
  try {
    const res = await API.graphql(
      graphqlOperation(getMinMaxInvoiceDate, {
        serialnumber: data?.seriesVouchers?.value,
        invoicetypecd: "Purchase",
        invoiceid: params?.id && !isNaN(params?.id) ? params.id : 0,
      })
    );

    const openingBalanceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate ?? null;
    setFirstInvoiceDate(openingBalanceDate);
    const invoiceDate =savedPostingDate? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;
    setData((prev) => ({ ...prev, invoiceDate }));
    setInitialState((prev) => ({ ...prev, invoiceDate }));
  } catch (error) {
    setBackdropOpen(false);
    console.log("error", error);
  }
}

  useEffect(() => {
    if(params?.id){
    if((invoiceEntry && invoiceEntry?.purchaseid)){
        getLastPurchaseInvoice();
    }
    }else{
    getLastPurchaseInvoice();
    }
  }, [getCompany,data?.seriesVouchers?.value,savedPostingDate]);
  useEffect(()=>{
      if(currentPostingDate){
      setSavedPostingDate(currentPostingDate);
      }
    },[currentPostingDate]);

  function print(htmlOnly) {
    try {
      let companyDatas = JSON.parse(JSON.stringify(companyData));
      let html = PurchaseTaxablePrint({
        data,
        totGstCess: totGSTCess,
        totGST,
        totNetAmount: Number(netAmountToPay),
        totDiscount,
        totAmount: totAmt,
        tabelTotAmount: totAmt,
        totTaxableAmount: totTaxAmt,
        bankDetails: {},
        registrationType: companyData.relatedcompanydetailsnew?.[0]?.registrationtype,
        suppierAddressDetals: billingAddressDetails,
        companyDetails: companyDatas,
        nonItems,
        items,
        units,
        nonItemwiseTableAmount: totNetAmt,
        invTransArr: invTransArr,

        totGstRate: totGST,
        companyState: companyState,
        stateName: billingAddressDetails.stateCD,
        countryName: billingAddressDetails.countryCD,
        stateOfSupply: billingAddressDetails.districtCD,
      });
      console.log(html);
      if (htmlOnly) {
        return html;
      } else {
        printJS({
          printable: html,
          type: 'raw-html',
        });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }
  const MailIt = async (InvoiceName) => {
    let html = PurchaseTaxablePrint({
      data,
      totGstCess: totGSTCess,
      totGST,
      totNetAmount: Number(netAmountToPay),
      totDiscount,
      totAmount: totAmt,
      tabelTotAmount: totAmt,
      totTaxableAmount: totTaxAmt,
      bankDetails: {},
      registrationType: companyData.relatedcompanydetailsnew?.[0]?.registrationtype,
      suppierAddressDetals: billingAddressDetails,
      companyDetails: companyData,
      nonItems,
      items,
      units,
      nonItemwiseTableAmount: totNetAmt,
      invTransArr: invTransArr,
      // journalhtmlItems,
      // journalhtmlNonItems,
      totGstRate: totGST,
      companyState: companyState,
      stateName: billingAddressDetails.stateCD,
      countryName: billingAddressDetails.countryCD,
      stateOfSupply: billingAddressDetails.districtCD,
    });
    console.log('3');
    try {
      const option = {
        method: 'POST',
        url: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws/',
        data: JSON.stringify({ html, InvoiceName }),
      };
      return await axios(option);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  };

  const [shareOpen, setShareOpen] = useState('');
  
  // Email sending states
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  
  // Email modal hook
  const { openModal } = useSendEmailModal(['purchaseinvoice', 'customer', 'supplier']);

  const { data: paymentSettingsList } = useGetPaymentSettingsQuery();
  const { enable_creditperiod: Enable_CreditPeriod, enable_itemwiseentry: Enable_ItemWiseEntry } = paymentSettingsList?.[0] ?? {};

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const ids = [
    'partyCreationModal',
    'addItemModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'SettingsModal',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          if (!anyElementExists()) saveEditChanges();
        }
      : params?.view !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
  return (
    <Box className="PageHeight">
      {modalOpen && <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />}

      {viewMode === true && invoiceEntry?.cancelflag ? (
        <>
          <Box
            sx={{
              position: 'sticky',
              top: '10px',
              borderRadius: '8px',
              marginBottom: '0px',
              padding: { xs: '10px 0px', sm: '10px 10px' },
              transition: 'all 1s ease-in-out',
            }}
          >
            <Alert
              variant="standard"
              sx={{
                color: 'red',
                boxShadow: 'none',
                width: 450,
              }}
              severity="error"
            >
              {invoiceEntry?.cancelflag === 1 ? 'Purchase Invoice cancelled. No further updates can be made.' : null}
            </Alert>
          </Box>
          <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
            <CancelUI />
          </Box>
        </>
      ) : null}

      <Box
        className="darkDisabledInputs"
        sx={{
          opacity: viewMode === true && invoiceEntry?.cancelflag ? '0.5' : '1',
          cursor: viewMode === true && invoiceEntry?.cancelflag ? 'no-drop' : 'default',
        }}
      >
        <Box
          sx={{
            borderRadius: '8px',
            // marginBottom: "10px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            padding: { xs: '10px 0px', sm: '0px 0px' },
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <InvoiceBasicDetails
            todayDate={todayDate}
            moment={moment}
            accountDetails={accountDetails}
            invoiceLabels={{
              partyName: 'Supplier Name',
              gstINName: 'Supplier GSTIN',
              seriesName: 'Voucher Series Name',
              voucherName: 'Voucher Number',
              voucherValue: 'voucherNumber',
              dateName: 'Voucher Date',
              seriesValue: 'seriesVouchers',
              voucherType: 'PurchaseInvoice',
              orderNumberName: 'Supplier Invoice Number',
              voucherModalName: 'Voucher Number Settings',
              orderDateName: 'Supplier Invoice Date',
            }}
            partyTypeCD={'SUPPLIER'}
            params={params}
            Type="Purchase"
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'hidden',
            marginTop: '24px',
            // marginBottom: "10px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '0px 5px',
            },
            '.MuiTableCell-head': {
              borderBottom: '0px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box sx={{ m: 2, mt: 0, mb: 0, ml: 0 }}>
            <EntryTable
              Type="Purchase"
              params={params}
              invoiceLabels={{
                partyName: 'Supplier Name',
                gstINName: 'Supplier GSTIN',
                seriesName: 'Voucher Series Name',
                voucherName: 'Voucher Number',
                voucherValue: 'voucherNumber',
                dateName: 'Voucher Date',
                seriesValue: 'seriesVouchers',
                voucherType: 'PurchaseInvoice',
                orderNumberName: 'Supplier Invoice Number',
                voucherModalName: 'Voucher Number Settings',
                orderDateName: 'Supplier Invoice Date',
              }}
              labelNamesOfTds={{
                tdsOrTcsType: '1',
                amountName: 'Purchase Amount',
                tcsOrTdsName: 'Less TDS if any',
                tcsOrTdsLabel: 'TDS Section',
                tcsOrTdsAmountLabel: 'TDS (%)',
                amountAfterLabel: 'Amount(After TDS)',
              }}
              labelNamesOfTcs={{
                tdsOrTcsType: '2',
                amountName: 'Purchase Amount',
                tcsOrTdsName: 'Add TCS if any',
                tcsOrTdsLabel: 'TCS Section',
                tcsOrTdsAmountLabel: 'TCS (%)',
                amountAfterLabel: 'Amount(After TCS)',
              }}
            />
          </Box>
        </Box>
        <Box
          className="custom-scrollbar"
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'scroll',
            // marginBottom: "10px",
            mt: 3,
            border: { xs: 'none', lg: '1px solid black' },
            borderColor: 'input.label',
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '4px 10px',
              // fontSize: "13px",
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '10px 8px',
              borderBottom: '0px',
              fontSize: '13px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box
            className="custom-scrollbar"
            sx={{
              m: 1,
              marginTop: '0px',
              marginBottom: '0px',
              marginLeft: '0px',
              display: 'flex',
              // flexWrap: { xs: 'wrap', md: 'wrap' },
              flexDirection: { xs: 'column', lg: 'row' },
              overflow: 'scroll',
            }}
          >
            <HsnandJournalTab Type="Purchase" />
            <Box
              sx={{
                flex: { xs: 1, lg: 0.5 },
                // m: "5px",
                // border: "1px solid #C9C9C9",
                // borderColor: "input.label",
                height: 370,
                p: '5px',
                overflowX: 'none',
                border: { xs: 'solid 1px gray', lg: 'none' },
                borderLeft: { lg: '1px solid gray' },
                marginTop: '10px',
              }}
            >
              <TotalAmountLabels
                labelNamesOfTds={{
                  tdsOrTcsType: '1',
                  amountName: 'Purchase Amount',
                  tcsOrTdsName: 'Less TDS if any',
                  tcsOrTdsLabel: 'TDS Section',
                  tcsOrTdsAmountLabel: 'TDS (%)',
                  amountAfterLabel: 'Amount(After TDS)',
                }}
                labelNamesOfTcs={{
                  tdsOrTcsType: '2',
                  amountName: 'Purchase Amount',
                  tcsOrTdsName: 'Add TCS if any',
                  tcsOrTdsLabel: 'TCS Section',
                  tcsOrTdsAmountLabel: 'TCS (%)',
                  amountAfterLabel: 'Amount(After TCS)',
                }}
                Type="Purchase"
              />
            </Box>
          </Box>
        </Box>
        {/* <Box
        className={viewMode === true ? "disable-interactions" : ""}
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",

          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <PaymentDetails
          todayDate={todayDate}
          moment={moment}
          paymentType={"Payment Details"}
          paymentLabels={{
            seriesName: "Payment Series Name",
            voucherName:
              data.paymentType == "Cash"
                ? "Cash Payment Number"
                : "Bank Payment Number",
            voucherValue: "transactionVoucher",
            seriesValue: "transactionSeries",
            voucherType: "Payment",
            accLabel: "Paid To Account (Dr)",
            accNames: "Paid To Account",
            amountName: "Paid Amount",
            dueDateName: "Purchase Due Date",
            voucherModalName: "Payment Number Settings",
          }}
          Type="Purchase"
          Enable_CreditPeriod={Enable_CreditPeriod}
        />
      </Box> */}

        <Grid lg={12} sx={{ marginTop: '16px', marginBottom: '0px' }}>
          <Box
            sx={{
              padding: { xs: '10px 0px', sm: '0px 0px' },

              display: 'flex',
              gap: '20px',
              flexDirection: { xs: 'column', md: 'column', lg: 'row' },
            }}
          >
            <Grid
              item
              container
              lg={3}
              xs={12}
              md={12}
              sx={{
                // padding: "0px 10px",
                display: 'flex',
                flexDirection: 'column',
                '.MuiPaper-root': {
                  boxShadow: 'none',
                },
              }}
            >
              <Description labelName="Purchase Description" Type="Purchase" />
            </Grid>
            {/* <Grid item container lg={9} xs={12} md={12}> */}
            <MultiFileAttachment Type="Purchase" />
            {/* </Grid> */}
          </Box>
        </Grid>
      </Box>
      {/* {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? ( */}
      <DraggableAction
        actionType={params?.id && params?.view !== true ? 'edit' : invoiceEntry?.cancelflag === 1 ? 'cancelled' : 'save'}
        from={'purchase'}
        onExit={() => {
          navigate('/allpurchaseandexpense');
        }}
        onSave={
          params?.id && params?.view !== true
            ? () => {
                saveEditChanges();
              }
            : params?.view !== true
            ? () => saveChanges({ new: false })
            : null
        }
        onEnableEdit={() => {
          navigate('/editnewpurchasetax', {
            state: { id: invoiceEntry?.purchaseid },
          });
        }}
        onPrint={viewMode === true ? () => fetchAndPrintPDF(uri) : null}
        onCancel={
          params?.view == true || params?.id
            ? () => {
                setCancelModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/allpurchaseandexpense',
                  todo: 'cancel',
                  linked: paymentTransID !== '',

                  from: 'purchase',
                });
              }
            : null
        }
        onDelete={
          params?.view == true || params?.id
            ? () => {
                setDeleteModalStatus(true);
                setItemData({
                  id: invoiceEntry?.purchaseid,
                  nav: '/allpurchaseandexpense',
                  todo: 'delete',
                  linked: paymentTransID !== '',

                  from: 'sales',
                });
              }
            : null
        }
        onPreview={
          // (params?.view == true || Number.isNaN(params?.id)) && data.partyName.label !== ''
          //   ? () => {
          //       setPreviewSalesTaxableModal(true);
          //     }
          //   : null
          () => {
            setPreviewSalesTaxableModal(true);
          }
        }
        onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
        onReset={
          params?.view !== true
            ? () => {
                if (params?.id) {
                  setData(initialState);
                  setItems(initItemTableDta.length > 0 ? initItemTableDta : [newItemObj]);
                  setNonItems(initNonItemTableData.length > 0 ? initNonItemTableData : [newNonItemObj]);
                  setItemsRows(initialAttachments);
                } else {
                  // setData((prevData) => ({
                  //   ...resetData, // Reset all fields
                  //   transactionVoucher: prevData?.transactionVoucher,
                  //   voucherNumber: prevData?.voucherNumber, // Preserve voucherNumber
                  //   placeOfSupply: prevData?.placeOfSupply, // Preserve placeOfSupply
                  //   seriesVouchers: prevData?.seriesVouchers,
                  //   transactionSeries: prevData?.transactionSeries,
                  //   invoiceDate: prevData?.invoiceDate,
                  //   customerOrderDate: prevData?.customerOrderDate,
                  // }));
                  setData(initialState);
                  setNonItems([resetNonItems]);
                  setItems([resetItems]);
                  setItemValid(true);
                  setNonItemValid(true);
                  setItemsRows([]);
                }
              }
            : null
        }
      />
      {/* ) : null} */}

      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={'Cancel'}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          netAmountToPay={netAmountToPay}
          companyState={companyState}
          Type={'Purchase'}
          path={url}
        />
      ) : null}
      {deleteModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteModalStatus}
          setOpen={setDeleteModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          actionType={'Delete'}
          Type={'Purchase'}
          path={url}
        />
      ) : null}

      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="allpurchaseandexpense" />
      <EInvAuth
        open={eInvAuthModalProps.open}
        setOpen={(val) => {
          console.log(val, 'valvalval');
          setEInvAuthModalProps((prev) => ({ ...prev, open: val }));
        }}
        checkbox={connectCheckbox}
        allSales={true}
        setBackdropOpen={setBackdropOpen}
        onComplete={eInvAuthModalProps.onComplete}
      />
      <Loader open={backdropOpen} />
      <ShareModal
        open={shareOpen}
        emailData={{
          selectedRow: individualEmailSelection?.map((inv) => ({
            id: Number(inv.invoiceid),
            recipientId: Number(inv.PartyID),
            email: inv.Email,
            name: inv.PartyDisplayName,
            invoiceNumber: inv.invoicenumber,
          })),
          type: 'purchaseInvoice',
        }}
        setOpen={setShareOpen}
        onClose={() => (isVoucher ? isVoucher(false) : navigate('/allpurchaseandexpense'))}
        progress={progress}
      />
      {previewSalesTaxableModal && (
        <PreviewSalesTaxable open={previewSalesTaxableModal} setOpen={setPreviewSalesTaxableModal} getHtml={print} />
      )}
    </Box>
  );
}

export default NewPurchaseInvoiceTaxPrime;
